export default __webpack_public_path__ + "static/media/bg-nextsong.d503d3b3.svg";